export const DEFINITIONTYPE_EDITABILITY: string = "Editability";
export const DEFINITIONTYPE_HINT: string = "Hint";
export const DEFINITIONTYPE_REDIRECT: string = "Redirect";
export const DEFINITIONTYPE_REQUIRED_FIELD: string = "RequiredField";
export const DEFINITIONTYPE_VISIBILITY: string = "Visibility";
export const DEFINITIONTYPE_POPULATION: string = "Population";

export const rules = {
    required: (value: any) => {
        return value ? true : 'Wird benötigt'
    },
    optionalEmail: (value: string) => {
        return (!value || isValidEmailAddress(value)) ? true : 'Ungültige Emailaddresse'
    },
    email: (value: string) => {
        return isValidEmailAddress(value) ? true : 'Ungültige Emailaddresse'
    },
    instituteIdentifier: (value: string) => {
        return /^\d{4}$/.test(value) ? true : '4 Ziffern';
    },
    optionalPhone: (value: string) => {
        return (value == undefined || /^(|[\d-]+)$/.test(value)) ? true : 'Ziffern und Bindestrich erlaubt';
    },
    validUserName: (v: any) => !v || /^[0-9a-zA-Z_.-]+$/.test(v) ||
        "Benutzername darf nur Zeichen wie 'A-Z', '0-9', '_' oder '-' enthalten",
    password: {
        min: (v: any) => !v || v.length >= 6 || 'Mindestens 6 Zeichen',
        uppercase: (v: any) => !v || (/[A-Z]/.test(v)) || 'Mindestens 1 Großbuchstabe',
        lowercase: (v: any) => !v || (/[a-z]/.test(v)) || 'Mindestens 1 Kleinbuchstabe',
        number: (v: any) => !v || (/[0-9]/.test(v)) || 'Mindestens 1 Zahl',
        specialSign: (v: any) => !v || (/[!§$%&/()=.,;:-]/.test(v)) || 'Mindestens 1 Sonderzeichen aus !§$%&/()=.,;:-'
    },
}

function isValidEmailAddress(value: string): boolean {
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return (!!value && pattern.test(value));
}
